"use client";

import * as React from "react";
import type { PortfolioSection } from "../../types";
import { useSectionStatusReporter } from "../../providers/section-status-provider";

export interface SectionCardProps {
  /** 부모에 로딩/빈 상태를 보고할 때 쓰는 섹션 식별자. */
  sectionKey: PortfolioSection;
  title: string;
  icon: string;
  iconFit?: "cover" | "contain";
  isEmpty: boolean;
  /** 최초 데이터 로딩 여부. 로딩 중에는 isEmpty를 확정 상태로 보지 않는다. */
  loading?: boolean;
  children?: React.ReactNode;
}

export function SectionCard({
  sectionKey,
  title,
  icon,
  iconFit = "cover",
  isEmpty,
  loading = false,
  children,
}: SectionCardProps) {
  const reporter = useSectionStatusReporter();

  React.useEffect(() => {
    reporter?.report(sectionKey, { loading, empty: isEmpty });
  }, [reporter, sectionKey, loading, isEmpty]);

  React.useEffect(
    () => () => reporter?.unregister(sectionKey),
    [reporter, sectionKey],
  );

  // 보유 자산이 없는 카테고리는 카드 자체를 그리지 않는다.
  // 전체가 비었을 때의 안내는 부모(WalletPortfolioBody)의 전역 빈 화면이 담당.
  if (isEmpty) return null;

  return (
    <div className="wp-svc-card">
      <div className="wp-svc-card-head">
        <img
          className="wp-svc-card-icon"
          src={icon}
          alt=""
          style={{ objectFit: iconFit }}
        />
        <span className="wp-svc-card-title">{title}</span>
      </div>
      <div className="wp-svc-items">{children}</div>
    </div>
  );
}
